import { Avatar, Switcher } from '@octopus-do/octopus-storybook'
import type { TeammateDto } from '@store/reducers/dashboard/types'
import type React from 'react'

import { Divider } from '../Divider'
import css from './styles.module.css'

interface Props {
  member: TeammateDto
  checked: boolean
  disabled: boolean
  onChange: (id: string) => void
}

export const UserToggle: React.FC<Props> = ({
  member,
  checked,
  onChange,
  disabled,
}) => {
  const { name, color, avatar, id, role } = member
  const onToggle = () => onChange(id)
  return (
    <div key={id} className={css.toggle_container}>
      <div className={css.user_toggle}>
        <Avatar name={name} color={color} media={avatar} size="md" />
        <div className={css.info}>
          <span className={css.name}>{name}</span>
          <span className={css.role}>{role.toLowerCase()}</span>
        </div>
        <Switcher disabled={disabled} value={checked} onChange={onToggle} />
      </div>

      <div className={css.divider}>
        <Divider />
      </div>
    </div>
  )
}
